module.exports = __webpack_public_path__ + "img/IconDevice.0dd3899c.svg";